import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { XML, XMLList } from "sxml"; // type 0:全景视频;1:全景图片;2:矩阵图片;

export var transformPanoData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pid, productType, testEnv, preview) {
    var apiType, editData, pageType, startStr, startReplaceStr, endStr, endOffset, js, playerData, newVersionData, _newVersionData;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (productType === void 0) {
              productType = 1;
            }

            if (testEnv === void 0) {
              testEnv = true;
            }

            if (preview === void 0) {
              preview = true;
            }

            apiType = productType == 1 ? 'product' : productType == 0 ? 'video_v2' : 'matrix';
            _context.prev = 4;
            _context.next = 7;
            return fetch("https://" + (testEnv ? 'api-test' : 'apiv4') + ".720yun.com/member/my/" + apiType + "/" + pid, {
              redirect: 'follow',
              headers: {
                'App-Authorization': window.localStorage.getItem('720yun_v8_token'),
                // 'App-Authorization': '51jz082lqy5w2g7tz3202nyxgynm74ek',
                'App-Key': 'eByjUyLDG2KtkdhuTsw2pY46Q3ceBPdT'
              }
            }).then(function (response) {
              return response.json();
            });

          case 7:
            editData = _context.sent;
            pageType = productType == 1 ? 't' : productType == 0 ? 'v2' : 'm';
            startStr = productType == 1 ? 'window.__INITIAL_STATE__ = {' : productType == 0 ? 'window.__INITIAL_STATE__ = {' : 'window.matrix = {';
            startReplaceStr = productType == 1 ? 'window.__INITIAL_STATE__ = ' : productType == 0 ? 'window.__INITIAL_STATE__ = ' : 'window.matrix = ';
            endStr = productType == 1 ? '<script src="https://ssl-static2.720static.com/js/polyfill.min.js"></script>' : productType == 0 ? "window.playerVersion" : '<script src="https://ssl-static2.720static.com/js/polyfill.min.js"></script>';
            endOffset = productType == 1 ? 16 : productType == 0 ? 49 : 16;
            _context.next = 15;
            return fetch("https://" + (testEnv ? 'test.' : 'www.') + "720yun.com/" + pageType + "/" + pid).then(function (response) {
              return response.text();
            }).then(function (html) {
              var startAt = html.indexOf(startStr);
              var endAt = html.indexOf(endStr) - endOffset;
              return html.substring(startAt, endAt).replace(startReplaceStr, 'window.tempPanoData = ');
            });

          case 15:
            js = _context.sent;

            if (js.endsWith('<')) {
              js = js.substring(0, js.length - 1);
            }

            eval(js);
            playerData = window.tempPanoData;
            window.tempPanoData = undefined;

            if (!(editData.success == 1)) {
              _context.next = 30;
              break;
            }

            if (!(productType == 0)) {
              _context.next = 26;
              break;
            }

            newVersionData = toNewVersionVideo(playerData, editData.data, testEnv, preview); // console.log(newVersionData);

            return _context.abrupt("return", newVersionData);

          case 26:
            _context.next = 28;
            return toNewVersion(playerData, editData.data, productType, testEnv, preview);

          case 28:
            _newVersionData = _context.sent;
            return _context.abrupt("return", _newVersionData);

          case 30:
            throw new Error("error");

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](4);
            console.log('err', _context.t0);

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 33]]);
  }));

  return function transformPanoData(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default transformPanoData;

var fetchXMLData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, testEnv) {
    var js, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url).then(function (response) {
              return response.text();
            }).then(function (html) {
              var startAt = html.indexOf("window.__INITIAL_STATE__ = {");
              var endAt = html.indexOf('<script src="https://ssl-static2.720static.com/js/polyfill.min.js"></script>') - 16;
              return html.substring(startAt, endAt).replace('window.__INITIAL_STATE__ = ', 'window.tempPanoData = ');
            });

          case 2:
            js = _context2.sent;
            eval(js);
            data = window.tempPanoData;
            window.tempPanoData = undefined; // if (data.sceneType != 1) {
            //     throw Error('目前仅支持全景图片的转化');
            // }

            return _context2.abrupt("return", data);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchXMLData(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var toNewVersion = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(originData, editData, productType, testEnv, preview) {
    var _flag;

    var str, xml, json, productData, category, i, rootItem, categoryItem, childrenIds, children, _i, categoryConfig, logo, flag, enterCover, startAnime, autoRotateXML, autoRotate, tourTip, config, links, customButton, originScenes, scenes, panoData;

    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (testEnv === void 0) {
              testEnv = false;
            }

            if (preview === void 0) {
              preview = true;
            }

            str = originData.xml;
            xml = new XML(str);
            json = originData.data;

            if (productType == 2) {
              json.product = json.matrix;
            }

            productData = {
              privilege: json.product.config["switch"].enablePassword == 1 && !preview && json.author.expired == 0 ? 2 : 1,
              password: json.product.property.password && json.product.property.password.length ? json.product.property.password : undefined,
              selected: 0,
              //json.product.property.selected,
              memberId: json.author.id,
              expired: json.product.expired,
              name: json.product.property.name,
              createDate: json.product.property.createDate,
              tid: json.product.property.pid,
              version: 1,
              memberUid: json.author.uid,
              updateDate: json.product.updateDate,
              status: json.product.status,
              remark: json.product.property.remark == undefined ? '' : json.product.property.remark.length <= 1999 ? json.product.property.remark : json.product.property.remark.slice(0, 1999),
              expireDate: json.product.expireDate,
              id: 0,
              keywords: json.product.property.keywords,
              likeCount: json.product.linkCount,
              json: "",
              thumbUrl: json.product.property.thumbUrl,
              pvCount: json.product.pvCount,
              author: json.author,
              shareConfig: JSON.stringify(editData.config.qrLogo && !isEmpty(editData.config.qrLogo) ? {
                qrMediaId: editData.config.qrLogo.mediaId,
                qrMediaUrl: editData.config.qrLogo.url
              } : {})
            };
            category = [];

            if (json.product.config.categoryRoot && Object.keys(json.product.config.categoryRoot).length > 0) {
              for (i = 0; i < json.product.config.categoryRoot.length; i++) {
                rootItem = json.product.config.categoryRoot[i];
                categoryItem = {
                  id: parseInt(rootItem.children.length == 1 ? rootItem.children[0] : rootItem.id),
                  name: rootItem.title
                };

                if (rootItem.children.length > 1) {
                  childrenIds = rootItem.children;
                  categoryItem.children = childrenIds.map(function (id) {
                    var name = "";

                    for (var j = 0; j < json.product.config.category.length; j++) {
                      var element = json.product.config.category[j];

                      if (element.id == id) {
                        name = element.title;
                      }
                    }

                    return {
                      id: parseInt(id),
                      name: name
                    };
                  });
                }

                category.push(categoryItem);
              }
            } else if (json.product.config.category && json.product.config.category.length > 0) {
              children = [];

              for (_i = 0; _i < json.product.config.category.length; _i++) {
                children.push({
                  id: parseInt(json.product.config.category[_i].id),
                  name: json.product.config.category[_i].title
                });
              }

              category.push({
                id: 100,
                name: "默认一级分组",
                children: children
              });
            }

            if (category.length == 0) {
              category.push({
                id: 1,
                name: "默认分组"
              });
            }

            categoryConfig = {
              buttonMediaId: 0,
              //(editData.config.category && editData.config.category.icon) ? (editData.config.category.icon.type == 2 ? editData.config.category.icon.mediaId : 0) : 0,
              buttonMediaUrl: '',
              //editData.config.category.icon ? (editData.config.category.icon.url || '') : undefined,
              buttonTitle: json.product.config.categoryGlobal.groupName,
              enabledColumn: 1,
              columnStyle: 0,
              categoryAutoSwitch: 0,
              switchCategoryShowFirstScene: json.product.config["switch"].showSceneAuto,
              isDefaultShowColumn: json.product.config["switch"].showMenu,
              initScene: json.product.config.initScene && json.product.config.initScene.enabled == 1 ? parseInt(json.product.config.initScene.sceneId) : 0
            };
            logo = isEmpty(json.product.config.logo) ? {} : {
              type: json.product.config.logo.enabled == 0 ? 0 : json.product.config.logo.url != "" ? 2 : 1,
              iconMediaId: editData.logo.media_id,
              iconMediaUrl: json.product.config.logo.url,
              scale: 1,
              action: json.product.config.logo.link && json.product.config.logo.link.length > 0 ? 1 : 0,
              linkUrl: json.product.config.logo.link,
              openMethod: 1,
              turnOffBgMusicWhenLayerOpen: 1,
              turnOffBgVoiceWhenLayerOpen: 1
            };
            flag = (_flag = {
              showAuthorName: json.product.config["switch"].showAuth,
              showTourPV: json.product.config["switch"].showPv,
              showTourRemark: json.product.config["switch"].showRemark,
              showFullscreenBtn: json.product.config["switch"].showFullscreen,
              showVRBtn: json.product.config["switch"].enableVr,
              showViewSwitchBtn: json.product.config["switch"].enableViewchange,
              showGyroBtn: json.product.config["switch"].showGyro,
              defaultEnabledGyro: json.product.config["switch"].enableGyro,
              showShareBtn: json.product.config["switch"].enableShare,
              showLikeBtn: json.product.config["switch"].enableLike,
              showCommentBtn: json.product.config["switch"].enableComment != undefined ? json.product.config["switch"].enableComment : 1,
              showComment: json.product.config["switch"].showComment != undefined ? json.product.config["switch"].showComment : 1,
              showSceneName: json.product.config["switch"].showSceneName,
              showRemarkBtn: json.product.config["switch"].showRemark
            }, _flag["showCommentBtn"] = preview ? 0 : json.product.config["switch"].enableComment != undefined ? json.product.config["switch"].enableComment : 1, _flag["showComment"] = preview ? 0 : json.product.config["switch"].showComment != undefined ? json.product.config["switch"].showComment : 1, _flag.showCommentBtnV2 = preview ? 0 : json.product.config["switch"].enableComment != undefined ? json.product.config["switch"].enableComment : 1, _flag);
            enterCover = !json.product.config.enterCover ? {} : {
              type: 0,
              bgColor: colorAlphaObjToString(hexToRgb(json.product.config.enterCover.backgroundColor), 1),
              bgImageId: editData.config.enterCover.backgroundImageId,
              bgImageUrl: json.product.config.enterCover.backgroundImageUrl,
              pcCoverId: editData.config.enterCover.pcCoverId,
              pcCoverUrl: json.product.config.enterCover.pcCoverUrl,
              pcShowPosition: parseInt(json.product.config.enterCover.pcShowType),
              mobileCoverId: editData.config.enterCover.mobileCoverId,
              mobileCoverUrl: json.product.config.enterCover.mobileCoverUrl,
              mobileShowPosition: parseInt(json.product.config.enterCover.mobileShowType),
              enterMethod: parseInt(json.product.config.enterCover.enterType),
              enterDuration: Math.max(1, parseFloat(json.product.config.enterCover.enterDuration)),
              showCountDown: parseInt(json.product.config.enterCover.showCountDown)
            };
            startAnime = {
              pano: json.product.config["switch"].enableLittleplanet == undefined ? json.product.config["switch"].starView == undefined ? 1 : json.product.config["switch"].starView : json.product.config["switch"].enableLittleplanet,
              video: json.product.config["switch"].enableLittleplanet == undefined ? json.product.config["switch"].starView == undefined ? 1 : json.product.config["switch"].starView : json.product.config["switch"].enableLittleplanet,
              matrix: json.product.config["switch"].enableLittleplanet == undefined ? 1 : json.product.config["switch"].enableLittleplanet
            };

            if (startAnime.pano == 3) {
              startAnime.pano = 4;
            } else if (startAnime.pano == 4) {
              startAnime.pano = 3;
            }

            autoRotateXML = productType == 2 ? undefined : xml.get("config").at(0).get("panos").at(0).get("pano").at(0).get("autoplay").at(0);
            autoRotate = productType == 2 ? undefined : {
              enabled: parseInt(autoRotateXML.getProperty('enabled')),
              hiddenThumbSceneNoEnter: 1 // parseInt(autoRotateXML.hasProperty("hiddenscene_noenter") ? autoRotateXML.getProperty("hiddenscene_noenter") : 1),

            };
            tourTip = json.product.config.scenes[0].startImage != undefined && json.product.config.scenes[0].startImage.config != undefined ? {
              pcMediaId: editData.scenes[0].config.startImage.pc ? editData.scenes[0].config.startImage.pc.mediaId : undefined,
              pcMediaUrl: json.product.config.scenes[0].startImage.pc ? json.product.config.scenes[0].startImage.pc.image : undefined,
              mobileMediaId: editData.scenes[0].config.startImage.mobile ? editData.scenes[0].config.startImage.mobile.mediaId : undefined,
              mobileMediaUrl: json.product.config.scenes[0].startImage.mobile ? json.product.config.scenes[0].startImage.mobile.image : undefined,
              duration: json.product.config.scenes[0].startImage.config ? parseInt(json.product.config.scenes[0].startImage.config.duration) > 0 ? parseInt(json.product.config.scenes[0].startImage.config.duration) : 1 : 5,
              enabled: json.product.config.scenes[0].startImage.config ? json.product.config.scenes[0].startImage.config.duration > 0 ? 1 : 0 : 1
            } : {
              duration: 5,
              enabled: 1
            };
            config = {
              language: {
                type: json.product.config.language != undefined && json.product.config.language.type != undefined ? json.product.config.language.type : 1,
                showButton: json.product.config.language != undefined && json.product.config.language.showButton != undefined ? json.product.config.language.showButton : 0,
                relationUrl: json.product.config.language != undefined && json.product.config.language.linkData != undefined && json.product.config.language.linkData != '' ? "https://" + (testEnv ? 'test.' : 'www.') + "720yun.com/t/" + json.product.config.language.linkData : ""
              },
              ui: {},
              copyright: {
                content: "",
                title: ""
              },
              loading: json.product.config.loading
            };
            links = json.product.config.link;
            _context6.next = 23;
            return Promise.all(links.map( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(linkData) {
                var children, data;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return generateModel(linkData, editData.link[links.indexOf(linkData)], testEnv, json.author.uid, preview);

                      case 2:
                        children = _context3.sent;
                        data = {
                          type: linkData.action == 4 ? 0 : 1,
                          iconMediaId: linkData.iconType == 1 ? 0 : editData.link[links.indexOf(linkData)].img_id,
                          iconMediaUrl: linkData.iconUrl,
                          groupTitle: linkData.title,
                          children: linkData.action == 4 ? children : [children]
                        };
                        return _context3.abrupt("return", data);

                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x12) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 23:
            customButton = _context6.sent;
            originScenes = json.product.config.scenes;
            _context6.next = 27;
            return Promise.all(originScenes.map( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(scene) {
                var categoryDatas, sceneData, categoryId, sceneXML, imageXML, _i2, j, panoXML, panos, _i3, baseUrl, tiledimage, _i4, matrixFov, embeds, embedIds, embedsXML, _loop, _i5, tagLine, _embedsXML, _loop2, _i6, effect, sunXML, weatherXML, rainType, mediaId, mediaUrl, scale, flakes, speed, shake, wind, speedVariance, floor, windDir, invert, top, bottom, groups, hotspotIds, hotspotList, _loop3, _i7, sceneEditData, autoRotate;

                return _regeneratorRuntime.wrap(function _callee4$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        categoryDatas = json.product.config.category;
                        sceneData = categoryDatas.flatMap(function (x) {
                          return x.scenes;
                        }).filter(function (x) {
                          return x.id == scene.id;
                        })[0];
                        categoryId = categoryDatas.filter(function (x) {
                          return x.scenes.map(function (y) {
                            return y.id;
                          }).includes(scene.id);
                        })[0].id;
                        _i2 = 0;

                      case 4:
                        if (!(_i2 < xml.get("scene").size())) {
                          _context5.next = 19;
                          break;
                        }

                        if (!(xml.get("scene").at(_i2).getProperty("scene_id") == scene.id)) {
                          _context5.next = 16;
                          break;
                        }

                        sceneXML = xml.get("scene").at(_i2);
                        j = 0;

                      case 8:
                        if (!(j < sceneXML.get("image").size())) {
                          _context5.next = 15;
                          break;
                        }

                        if (!sceneXML.get("image").at(j).hasProperty("type")) {
                          _context5.next = 12;
                          break;
                        }

                        imageXML = sceneXML.get("image").at(j);
                        return _context5.abrupt("break", 15);

                      case 12:
                        j++;
                        _context5.next = 8;
                        break;

                      case 15:
                        return _context5.abrupt("break", 19);

                      case 16:
                        _i2++;
                        _context5.next = 4;
                        break;

                      case 19:
                        panos = xml.get("config").at(0).get(productType == 1 ? "panos" : "materials").at(0).get(productType == 1 ? "pano" : 'material');
                        _i3 = 0;

                      case 21:
                        if (!(_i3 < panos.size())) {
                          _context5.next = 28;
                          break;
                        }

                        if (!(panos.at(_i3).getProperty("name") == "s_" + scene.id)) {
                          _context5.next = 25;
                          break;
                        }

                        panoXML = panos.at(_i3);
                        return _context5.abrupt("break", 28);

                      case 25:
                        _i3++;
                        _context5.next = 21;
                        break;

                      case 28:
                        baseUrl = sceneXML.get("preview").at(0).getProperty("url").replace("/imgs/preview.jpg", "");

                        if (baseUrl.includes("?t=")) {
                          baseUrl = baseUrl.substring(0, baseUrl.indexOf('?t='));
                        }

                        tiledimage = {};

                        if (imageXML) {
                          tiledimage = [];

                          for (_i4 = 0; _i4 < imageXML.get("level").size(); _i4++) {
                            tiledimage.push({
                              w: imageXML.get("level").at(_i4).getProperty("tiledimagewidth"),
                              h: imageXML.get("level").at(_i4).getProperty("tiledimageheight"),
                              url: imageXML.get("level").at(_i4).get(productType == 1 ? "cube" : 'cylinder').at(0).getProperty("url").replace(baseUrl, "")
                            });
                          }
                        }

                        matrixFov = {};

                        if (productType == 2) {
                          matrixFov.voffset = imageXML.getProperty("voffset");
                          matrixFov.vfov = imageXML.getProperty("vfov");
                          matrixFov.hfov = imageXML.getProperty("hfov");
                        }

                        embeds = [];
                        embedIds = [];

                        try {
                          if (panoXML.get("embeds")) {
                            embedsXML = panoXML.get("embeds").at(0).get("embed");

                            _loop = function _loop(_i5) {
                              var embedXML = embedsXML.at(_i5);
                              var embedEditData = editData.scenes.filter(function (item) {
                                return item.id == scene.id;
                              })[0].config.embed.filter(function (item) {
                                return item.id == embedXML.getProperty("name");
                              })[0];
                              var embedData = generateEmbedHotspot(embedXML, scene.sort, scene, embedEditData);

                              if (embedData) {
                                embeds.push(embedData);
                                embedIds.push(embedXML.getProperty("name"));
                              }
                            };

                            for (_i5 = 0; _i5 < embedsXML.size(); _i5++) {
                              _loop(_i5);
                            }
                          }
                        } catch (_unused) {}

                        tagLine = [];

                        try {
                          if (panoXML.get("embeds")) {
                            _embedsXML = panoXML.get("embeds").at(0).get("embed");

                            _loop2 = function _loop2(_i6) {
                              var embedXML = _embedsXML.at(_i6);

                              var embedEditData = editData.scenes.filter(function (item) {
                                return item.id == scene.id;
                              })[0].config.embed.filter(function (item) {
                                return item.id == embedXML.getProperty("name");
                              })[0];
                              var tagLineData = generateTagline(embedXML, embedEditData);

                              if (tagLineData) {
                                tagLine.push(tagLineData);
                              }
                            };

                            for (_i6 = 0; _i6 < _embedsXML.size(); _i6++) {
                              _loop2(_i6);
                            }
                          }
                        } catch (_unused2) {}

                        effect = [];

                        try {
                          if (panoXML.get("sun")) {
                            sunXML = panoXML.get("sun").at(0);
                            effect.push({
                              type: 0,
                              id: "sun_" + sunXML.getProperty("id"),
                              style: "blinkstyle3",
                              ath: parseFloat(sunXML.getProperty("ath")),
                              atv: parseFloat(sunXML.getProperty("atv"))
                            });
                          }
                        } catch (_unused3) {}

                        _context5.prev = 41;

                        if (!panoXML.get("weather")) {
                          _context5.next = 107;
                          break;
                        }

                        weatherXML = panoXML.get("weather").at(0);
                        rainType = 1;
                        mediaId = editData.scenes.filter(function (item) {
                          return item.id == scene.id;
                        })[0].effect.media_id;
                        mediaUrl = editData.scenes.filter(function (item) {
                          return item.id == scene.id;
                        })[0].effect.url;
                        scale = 0.5;
                        flakes = 100;
                        speed = 0.3;
                        shake = 0;
                        wind = 0;
                        speedVariance = 100;
                        floor = 1;
                        windDir = 0;
                        invert = 0;
                        _context5.t0 = weatherXML.getProperty("size");
                        _context5.next = _context5.t0 === "2" ? 59 : _context5.t0 === "3" ? 69 : 79;
                        break;

                      case 59:
                        scale = 0.6;
                        flakes = 200;
                        speed = 0.4;
                        shake = 0;
                        wind = 0;
                        speedVariance = 100;
                        floor = 1;
                        windDir = 0;
                        invert = 0;
                        return _context5.abrupt("break", 79);

                      case 69:
                        scale = 0.7;
                        flakes = 300;
                        speed = 0.5;
                        shake = 0;
                        wind = 0;
                        speedVariance = 100;
                        floor = 1;
                        windDir = 0;
                        invert = 0;
                        return _context5.abrupt("break", 79);

                      case 79:
                        _context5.t1 = weatherXML.getProperty("id");
                        _context5.next = _context5.t1 === "0" ? 82 : _context5.t1 === "1" ? 87 : _context5.t1 === "3" ? 92 : _context5.t1 === "4" ? 102 : 106;
                        break;

                      case 82:
                        rainType = 2;
                        flakes = flakes * 3;
                        speed = weatherXML.getProperty("size");
                        scale = 0.3;
                        return _context5.abrupt("break", 106);

                      case 87:
                        rainType = 1;
                        flakes = flakes * 2;
                        speed = 10;
                        scale = 2;
                        return _context5.abrupt("break", 106);

                      case 92:
                        _context5.t2 = weatherXML.getProperty("type");
                        _context5.next = _context5.t2 === "1" ? 95 : _context5.t2 === "2" ? 97 : _context5.t2 === "3" ? 99 : 101;
                        break;

                      case 95:
                        rainType = 8;
                        return _context5.abrupt("break", 101);

                      case 97:
                        rainType = 7;
                        return _context5.abrupt("break", 101);

                      case 99:
                        rainType = 9;
                        return _context5.abrupt("break", 101);

                      case 101:
                        return _context5.abrupt("break", 106);

                      case 102:
                        rainType = 0;
                        scale = 1;
                        mediaUrl = weatherXML.getProperty("url");
                        return _context5.abrupt("break", 106);

                      case 106:
                        effect.push({
                          type: 1,
                          id: "effect_" + weatherXML.getProperty("id"),
                          rainType: rainType,
                          mediaId: mediaId,
                          mediaUrl: mediaUrl ? mediaUrl.replace('%$mediaDomain%', '') : undefined,
                          invert: invert,
                          flakes: flakes,
                          speed: speed,
                          speedVariance: speedVariance,
                          floor: floor,
                          shake: shake,
                          wind: wind,
                          windDir: windDir,
                          scale: scale
                        });

                      case 107:
                        _context5.next = 111;
                        break;

                      case 109:
                        _context5.prev = 109;
                        _context5.t3 = _context5["catch"](41);

                      case 111:
                        top = undefined;

                        try {
                          if (panoXML.get("top_circle")) {
                            top = {
                              stick: panoXML.get("top_circle") != undefined && panoXML.get("top_circle").at(0) != undefined && panoXML.get("top_circle").at(0).getProperty("is_float") == "0" ? 1 : 0,
                              scale: parseFloat(panoXML.get("top_circle").at(0).getProperty("scale") == undefined ? "1" : panoXML.get("top_circle").at(0).getProperty("scale")),
                              rotate: 0,
                              enabled: panoXML.get("top_circle") == null ? 0 : 1,
                              mediaId: panoXML.get("top_circle").at(0).getProperty("type") == "2" ? editData.scenes.filter(function (item) {
                                return item.id == scene.id;
                              })[0].config.mask.top.mediaId : 0,
                              mediaUrl: panoXML.get("top_circle").at(0).getProperty("type") == "2" ? panoXML.get("top_circle").at(0).getProperty("url").replace("%$mediaDomain%", "") : ""
                            };
                          }
                        } catch (e) {}

                        bottom = undefined;

                        try {
                          if (panoXML.get("bottom_circle")) {
                            bottom = {
                              stick: panoXML.get("bottom_circle") != undefined && panoXML.get("bottom_circle").at(0) != undefined && panoXML.get("bottom_circle").at(0).getProperty("is_float") == "0" ? 1 : 0,
                              scale: parseFloat(panoXML.get("bottom_circle").at(0).getProperty("scale") == undefined ? "1" : panoXML.get("bottom_circle").at(0).getProperty("scale")),
                              rotate: 0,
                              enabled: panoXML.get("bottom_circle") == null ? 0 : 1,
                              mediaId: panoXML.get("bottom_circle").at(0).getProperty("type") == "2" ? editData.scenes.filter(function (item) {
                                return item.id == scene.id;
                              })[0].config.mask.bottom.mediaId : 0,
                              mediaUrl: panoXML.get("bottom_circle").at(0).getProperty("type") == "2" ? panoXML.get("bottom_circle").at(0).getProperty("url").replace("%$mediaDomain%", "") : ""
                            };
                          }
                        } catch (e) {}

                        groups = scene.groups ? scene.groups.length == 0 ? {} : {
                          "bgColor": "0,0,0,0.5",
                          "fontColor": "255,255,255,1",
                          "activeBgColor": "40,110,250,1",
                          "activeFontColor": "255,255,255,1",
                          "defaultId": "h_0",
                          list: scene.groups.map(function (groupItem) {
                            return {
                              id: scene.groups.indexOf(groupItem) + 1,
                              name: groupItem.name,
                              view: {
                                type: 0
                              },
                              hotspots: {
                                type: 0,
                                list: groupItem.embeds
                              }
                            };
                          })
                        } : {};

                        if ((scene.groups ? scene.groups.length : 0) > 0) {
                          hotspotIds = scene.hotspot.map(function (hotspot) {
                            return hotspot.id;
                          }).concat(embedIds);
                          groups.list = [{
                            id: 'h_0',
                            name: '全部',
                            view: {
                              type: 0
                            },
                            hotspots: {
                              type: 0,
                              list: hotspotIds
                            }
                          }].concat(groups.list);
                        }

                        hotspotList = [];
                        _loop3 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop3(_i7) {
                          var hotspot, hotspotEditDatas, hotspotEditData, hotspotData;
                          return _regeneratorRuntime.wrap(function _loop3$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  hotspot = scene.hotspot[_i7];
                                  hotspotEditDatas = editData.scenes.filter(function (item) {
                                    return item.id == scene.id;
                                  })[0].hotspot.filter(function (item) {
                                    return (item.iconUrl || item.imageUrl) == (hotspot.iconUrl || hotspot.imageUrl);
                                  });
                                  hotspotEditData = hotspotEditDatas.length === 1 ? hotspotEditDatas[0] : hotspotEditDatas.filter(function (item) {
                                    return item.title == hotspot.title;
                                  }).at(0);
                                  hotspotEditData = hotspotEditData ? hotspotEditData : editData.scenes.filter(function (item) {
                                    return item.id == scene.id;
                                  })[0].hotspot[_i7];
                                  _context4.next = 6;
                                  return generateHotspot(hotspot, scene.hotspot.indexOf(hotspot), originData, hotspotEditData, json.author.uid, preview, testEnv, productType);

                                case 6:
                                  hotspotData = _context4.sent;
                                  hotspotList.push(hotspotData);

                                case 8:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _loop3);
                        });
                        _i7 = 0;

                      case 120:
                        if (!(_i7 < scene.hotspot.length)) {
                          _context5.next = 125;
                          break;
                        }

                        return _context5.delegateYield(_loop3(_i7), "t4", 122);

                      case 122:
                        _i7++;
                        _context5.next = 120;
                        break;

                      case 125:
                        sceneEditData = editData.scenes.filter(function (item) {
                          return item.id == scene.id;
                        })[0];

                        if (sceneEditData.autoplay && sceneEditData.autoplay.keepOriginView === true) {
                          sceneEditData.autoplay.keepOriginView = 1;
                        } else if (sceneEditData.autoplay && sceneEditData.autoplay.keepOriginView === false) {
                          sceneEditData.autoplay.keepOriginView = 0;
                        }

                        autoRotate = {
                          type: 1,
                          duration: sceneEditData.autoplay ? sceneEditData.autoplay.duration || 180 : 180,
                          stayTime: productType == 1 ? 180 : 30,
                          holdView: sceneEditData.autoplay ? sceneEditData.autoplay.keepOriginView || sceneEditData.view.autorotatekeepview || 0 : sceneEditData.view.autorotatekeepview || 0,
                          endOperation: sceneEditData.autoplay && sceneEditData.autoplay.enterNext == 0 ? 0 : 2
                        };
                        return _context5.abrupt("return", {
                          id: scene.id,
                          tourId: 0,
                          type: productType,
                          materialId: scene.materialId || scene.panoId,
                          name: scene.name,
                          thumbUrl: sceneData.thumb,
                          showThumb: parseInt(sceneData.showThumb),
                          categoryId: parseInt(categoryId ? categoryId : 1),
                          createDate: 0,
                          // TODO:
                          updateDate: 0,
                          // TODO:
                          multires: imageXML ? {
                            tiledimage: tiledimage,
                            level: imageXML.get("level").size()
                          } : {},
                          matrixFov: matrixFov,
                          // TODO:
                          transcodeTrack: {},
                          //TODO:
                          cdnDomain: scene.cdn,
                          path: baseUrl.replace("%$cdnDomain" + scene.cdn + "%", ""),
                          view: {
                            fovMax: panoXML.get("view").at(0).getProperty("fovmax"),
                            fovMin: panoXML.get("view").at(0).getProperty("fovmin"),
                            fov: panoXML.get("view").at(0).getProperty("fov"),
                            fovType: "MFOV",
                            loadSceneKeepView: sceneEditData.view.loadscenekeepview == undefined ? 0 : sceneEditData.view.loadscenekeepview,
                            autoRotateKeepView: sceneEditData.autoplay ? sceneEditData.autoplay.keepOriginView || sceneEditData.view.autorotatekeepview || 0 : sceneEditData.view.autorotatekeepview || 0,
                            vLookAt: panoXML.get("view").at(0).getProperty("vlookat"),
                            vLookAtMax: panoXML.get("view").at(0).getProperty("vlookatmax"),
                            vLookAtMin: panoXML.get("view").at(0).getProperty("vlookatmin"),
                            hLookAt: panoXML.get("view").at(0).getProperty("hlookat"),
                            hLookAtMax: productType == 1 ? panoXML.get("view").at(0).getProperty("hlookatmax") : undefined,
                            hLookAtMin: productType == 1 ? panoXML.get("view").at(0).getProperty("hlookatmin") : undefined,
                            flatFovType: productType == 1 ? 0 : parseInt(panoXML.get("view").at(0).getProperty("scale_to_fit")) == 0 ? 1 : 0,
                            maxPixelZoom: panoXML.get("view").at(0).getProperty("maxpixelzoom")
                          },
                          tid: "",
                          mask: {
                            top: top,
                            bottom: bottom
                          },
                          sort: scene.sort,
                          hotspot: hotspotList.concat(embeds),
                          tagLine: tagLine,
                          groups: groups,
                          sound: scene.sound == undefined || isEmpty(scene.sound) ? undefined : {
                            volume: parseFloat(scene.sound.volume),
                            autoPlay: parseInt(scene.sound.autoPlay),
                            isLoop: scene.sound.isLoop,
                            type: sceneEditData.config.sound.type == 1 ? 0 : 1,
                            mediaId: sceneEditData.config.sound.mediaId,
                            mediaUrl: scene.sound.url,
                            mediaName: sceneEditData.config.sound.name
                          },
                          voice: scene.voice == undefined || isEmpty(scene.voice) ? undefined : {
                            volume: scene.voice.volume,
                            autoPlay: scene.voice.autoPlay,
                            type: sceneEditData.config.voice.type == 1 ? 0 : 1,
                            isLoop: scene.voice.isLoop,
                            mediaId: sceneEditData.config.voice.mediaId,
                            mediaUrl: scene.voice.url,
                            mediaName: sceneEditData.config.voice.name
                          },
                          subtitle: scene.subtitle != undefined ? scene.subtitle.text == undefined ? [] : [{
                            text: scene.subtitle.text,
                            fontSize: 14,
                            fontColor: "255,255,255,1",
                            bgColor: "0,0,0,0.3",
                            spacing: 0,
                            rollingMode: 1,
                            rollingSpeed: parseFloat(scene.subtitle.speed) * 0.3,
                            pauseDuration: 10,
                            clickAction: scene.subtitle.url ? 1 : 0,
                            clickActionLink: scene.subtitle.url,
                            linkTarget: scene.subtitle.blank == 1 ? 1 : scene.subtitle.blank == 0 ? 2 : 0
                          }] : undefined,
                          effect: effect,
                          config: {
                            autoRotate: autoRotate
                          }
                        });

                      case 129:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee4, null, [[41, 109]]);
              }));

              return function (_x13) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 27:
            scenes = _context6.sent;
            panoData = {
              id: 1,
              privilege: json.product.config["switch"].enablePassword == 1 && !preview && json.author.expired == 0 ? 2 : 1,
              tid: json.product.property.pid,
              name: json.product.property.name,
              remark: json.product.property.remark == undefined ? '' : json.product.property.remark.length <= 1999 ? json.product.property.remark : json.product.property.remark.slice(0, 1999),
              keywords: json.product.property.keywords,
              thumbUrl: json.product.property.thumbUrl,
              createDate: json.product.property.createDate,
              updateDate: json.product.property.updateDate,
              templateId: 8,
              expired: json.product.property.expired,
              expireDate: json.product.property.expireDate,
              category: category,
              categoryConfig: categoryConfig,
              logo: logo,
              flag: flag,
              enterCover: enterCover,
              startAnime: startAnime,
              autoRotate: autoRotate,
              tourTip: tourTip,
              config: config,
              customButton: customButton,
              version: 1,
              scenes: scenes,
              shareConfig: JSON.stringify(editData.config.qrLogo && !isEmpty(editData.config.qrLogo) ? {
                qrMediaId: editData.config.qrLogo.mediaId,
                qrMediaUrl: editData.config.qrLogo.url
              } : {})
            };
            return _context6.abrupt("return", {
              panoData: productData,
              jsonData: panoData
            });

          case 30:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5);
  }));

  return function toNewVersion(_x7, _x8, _x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();

function generateEmbedHotspot(xmlData, zOrder, sceneData, embedEditData) {
  if (parseInt(xmlData.getProperty("embed_type")) == 5) {
    return undefined;
  }

  var title = "";
  var fontSize = xmlData.hasProperty("font_size") ? parseInt(xmlData.getProperty("font_size")) : 12;
  var fontColor = xmlData.hasProperty("font_color") ? hexColorAlphaObjToString(xmlData.getProperty("font_color"), parseFloat(xmlData.getProperty("font_color_alpha"))) : "255,255,255,1";
  var bgColor = xmlData.hasProperty("bg_color") ? hexColorAlphaObjToString(xmlData.getProperty("bg_color"), parseFloat(xmlData.getProperty("bg_color_alpha"))) : "0,0,0,0.5";

  if (xmlData.hasProperty("embed_type") && xmlData.getProperty("embed_type") == "5") {
    title = xmlData.getProperty("title");
  } else {
    title = xmlData.hasProperty("text") ? xmlData.getProperty("text") : "";
  }

  var hotspot = {
    id: xmlData.getProperty("name"),
    title: title,
    showTitle: 1,
    zOrder: zOrder,
    icon: generateEmbedIcon(xmlData, embedEditData),
    data: generateEmbedData(xmlData),
    keepView: 0,
    titleSetting: {
      align: "center",
      edge: "top",
      ox: 0,
      oy: 0,
      font: {
        fontSize: fontSize,
        fontColor: fontColor
      },
      background: {
        bgColor: bgColor,
        bgRoundedge: 5,
        borderWidth: 0,
        borderColor: "0,0,0,0"
      }
    }
  };

  if (sceneData.groups.length > 0) {
    var group = sceneData.groups.filter(function (group) {
      return group.embeds.includes(xmlData.getProperty("name"));
    });

    if (group.length > 0) {
      hotspot.groupId = sceneData.groups.indexOf(group[0]) + 1;
    }
  }

  return hotspot;
}

function generateTagline(xmlData, embedEditData) {
  var type = parseInt(xmlData.getProperty("embed_type"));

  if (type == 5) {
    return {
      id: "tagline_" + makeid(20),
      startAth: parseFloat((xmlData.get("point") || xmlData.get("value")).at(1).getProperty("ath")) || 0.001,
      startAtv: parseFloat((xmlData.get("point") || xmlData.get("value")).at(1).getProperty("atv")) || 0.001,
      endAth: parseFloat((xmlData.get("point") || xmlData.get("value")).at(0).getProperty("ath")) || 0.001,
      endAtv: parseFloat((xmlData.get("point") || xmlData.get("value")).at(0).getProperty("atv")) || 0.001,
      title: embedEditData.title,
      titleSetting: {
        alignMode: 0,
        // 文字位置 0中间, 1上方, 2下方
        distorted: 0,
        // 是否跟随画面缩放, 0/1, 默认1
        enableRotate: 0,
        // 是否开启自定义文字角度
        rotate: 0,
        // 文字角度 0-360
        fontSize: 12,
        // # 字号, 默认14
        fontColor: "255,255,255,1",
        // # 颜色  '0,0,0,1'
        bgColor: '0,0,0,0.5' //# 背景色 '0,0,0,1' RGBA

      },
      style: {
        lineWidth: Math.min(10, parseFloat(xmlData.getProperty("thickness"))),
        lineColor: hexColorAlphaObjToString(xmlData.getProperty("color"), parseFloat(xmlData.getProperty("alpha"))),
        pointMode: 0,
        pointColor: hexColorAlphaObjToString(xmlData.getProperty("color"), parseFloat(xmlData.getProperty("alpha")))
      }
    };
  }

  return undefined;
}

function generateEmbedIcon(xmlData, embedEditData) {
  var _ref6, _ref7;

  var type = 0;

  if (xmlData.hasProperty("embed_type")) {
    type = parseInt(xmlData.getProperty("embed_type"));
  }

  switch (type) {
    case 1:
      // 文字标记
      return {
        type: 1,
        ath: xmlData.hasProperty("ath") ? parseFloat(xmlData.getProperty("ath")) : 0,
        atv: xmlData.hasProperty("atv") ? parseFloat(xmlData.getProperty("atv")) : 0,
        edge: "bottom",
        lineType: xmlData.hasProperty("style_type") && xmlData.getProperty("style_type") == "1" ? 1 : 0,
        lineColor: xmlData.hasProperty("style_type") && xmlData.getProperty("style_type") == "1" ? '0,0,0,0.5' : '255,255,255,1',
        length: xmlData.hasProperty("style_type") && xmlData.getProperty("style_type") == "1" ? 0 : 30,
        media: {
          enabled: 0
        }
      };

    case 2:
      //图片
      var media = [];

      var _loop4 = function _loop4(i) {
        var url = xmlData.get("image").at(i).getProperty("url").replace("%$mediaDomain%", "");
        media.push({
          id: embedEditData.value.filter(function (item) {
            return item.url == url;
          })[0].mediaId,
          url: url
        });
      };

      for (var i = 0; i < xmlData.get("image").size(); i++) {
        _loop4(i);
      }

      return _ref6 = {
        type: 2,
        ath: xmlData.hasProperty("ath") ? parseFloat(xmlData.getProperty("ath")) : 0,
        atv: xmlData.hasProperty("atv") ? parseFloat(xmlData.getProperty("atv")) : 0,
        edge: "center",
        stick: true,
        rx: xmlData.hasProperty("rotation_x") ? parseFloat(xmlData.getProperty("rotation_x")) : 0,
        ry: xmlData.hasProperty("rotation_y") ? parseFloat(xmlData.getProperty("rotation_y")) : 0,
        rz: xmlData.hasProperty("rotation_z") ? parseFloat(xmlData.getProperty("rotation_z")) : 0,
        scaleLock: 1,
        scaleX: xmlData.hasProperty("scale") ? parseFloat(xmlData.getProperty("scale")) : 0.5,
        scaleY: xmlData.hasProperty("scale") ? parseFloat(xmlData.getProperty("scale")) : 0.5
      }, _ref6["scaleLock"] = 1, _ref6.positionType = 0, _ref6.autoPlayType = xmlData.hasProperty("play_type") ? parseInt(xmlData.getProperty("play_type")) == 0 ? 1 : 0 : 1, _ref6.autoPlayDuration = xmlData.hasProperty("interval") ? Math.min(parseFloat(xmlData.getProperty("interval")), 60) : 3, _ref6.media = media, _ref6;

    case 3:
      //序列帧
      return _ref7 = {
        type: 3,
        ath: xmlData.hasProperty("ath") ? parseFloat(xmlData.getProperty("ath")) : 0,
        atv: xmlData.hasProperty("atv") ? parseFloat(xmlData.getProperty("atv")) : 0,
        edge: "center",
        stick: true,
        rx: xmlData.hasProperty("rotation_x") ? parseFloat(xmlData.getProperty("rotation_x")) : 0,
        ry: xmlData.hasProperty("rotation_y") ? parseFloat(xmlData.getProperty("rotation_y")) : 0,
        rz: xmlData.hasProperty("rotation_z") ? parseFloat(xmlData.getProperty("rotation_z")) : 0,
        scaleLock: 1,
        scaleX: xmlData.hasProperty("scale") ? parseFloat(xmlData.getProperty("scale")) : 0.5,
        scaleY: xmlData.hasProperty("scale") ? parseFloat(xmlData.getProperty("scale")) : 0.5
      }, _ref7["scaleLock"] = 1, _ref7.positionType = 0, _ref7.media = [{
        id: embedEditData.value.mediaId,
        url: xmlData.getProperty("image_url").replace("%$mediaDomain%", ""),
        width: parseFloat(xmlData.getProperty("frame_width")),
        height: parseFloat(xmlData.getProperty("frame_height")),
        frame: parseFloat(xmlData.getProperty("frame_number")),
        duration: parseFloat(xmlData.getProperty("frame_speed"))
      }], _ref7;

    case 4:
      // 视频嵌入
      return {
        type: 4,
        ath: xmlData.hasProperty("ath") ? parseFloat(xmlData.getProperty("ath")) : 0,
        atv: xmlData.hasProperty("atv") ? parseFloat(xmlData.getProperty("atv")) : 0,
        edge: "center",
        stick: true,
        rx: xmlData.hasProperty("rotation_x") ? parseFloat(xmlData.getProperty("rotation_x")) : 0,
        ry: xmlData.hasProperty("rotation_y") ? parseFloat(xmlData.getProperty("rotation_y")) : 0,
        rz: xmlData.hasProperty("rotation_z") ? parseFloat(xmlData.getProperty("rotation_z")) : 0,
        scaleLock: 1,
        scaleX: xmlData.hasProperty("scale") ? parseFloat(xmlData.getProperty("scale")) : 0.5,
        scaleY: xmlData.hasProperty("scale") ? parseFloat(xmlData.getProperty("scale")) : 0.5,
        positionType: xmlData.hasProperty("position_type") ? parseInt(xmlData.getProperty("position_type")) : 0,
        hfov: xmlData.hasProperty("hfov") ? parseFloat(xmlData.getProperty("hfov")) : 0,
        yaw: xmlData.hasProperty("yaw") ? parseFloat(xmlData.getProperty("yaw")) : 0,
        pitch: xmlData.hasProperty("pitch") ? parseFloat(xmlData.getProperty("pitch")) : 0,
        roll: xmlData.hasProperty("roll") ? parseFloat(xmlData.getProperty("roll")) : 0,
        autoPlay: xmlData.hasProperty("play_type") ? parseInt(xmlData.getProperty("play_type")) == 1 ? 0 : 1 : 1,
        loop: xmlData.hasProperty("loop_type") ? parseInt(xmlData.getProperty("loop_type")) == 1 ? 0 : 1 : 0,
        mute: xmlData.hasProperty("muted") ? parseInt(xmlData.getProperty("muted")) : 0,
        turnOffBgMusicOnPlay: xmlData.hasProperty("music_pause") ? xmlData.hasProperty("music_pause") : 0,
        turnOffBgVoiceOnPlay: xmlData.hasProperty("sound_pause") ? xmlData.hasProperty("sound_pause") : 0,
        media: [{
          id: embedEditData.value.mediaId,
          url: xmlData.getProperty("video_url").replace("%$mediaDomain%", ""),
          coverUrl: xmlData.getProperty("cover_url").replace("%$mediaDomain%", ""),
          name: ""
        }]
      }; // case 5: // 标尺
      //     let points = [];
      //     for (let i = 0; i < (xmlData.get("point") || xmlData.get("value")).size(); i++) {
      //         points.push({
      //             ath: parseFloat((xmlData.get("point") || xmlData.get("value")).at(i).getProperty("ath")),
      //             atv: parseFloat((xmlData.get("point") || xmlData.get("value")).at(i).getProperty("atv")),
      //         });
      //     }
      //     return {
      //         type: 5,
      //         ath: xmlData.hasProperty("ath") ?
      //             parseFloat(xmlData.getProperty("ath")) : 0,
      //         atv: xmlData.hasProperty("atv") ?
      //             parseFloat(xmlData.getProperty("atv")) : 0,
      //         points,
      //         fillColor: hexColorAlphaObjToString(
      //             xmlData.getProperty("color"),
      //             parseFloat(xmlData.getProperty("alpha"))
      //         ),
      //         borderWidth: Math.min(parseFloat(xmlData.getProperty("thickness"))),
      //         borderColor: hexColorAlphaObjToString(
      //             xmlData.getProperty("color"),
      //             parseFloat(xmlData.getProperty("alpha"))
      //         ),
      //         overFillColor: hexColorAlphaObjToString(
      //             xmlData.getProperty("color"),
      //             parseFloat(xmlData.getProperty("alpha"))
      //         ),
      //         overBorderWidth: parseFloat(xmlData.getProperty("thickness")),
      //         overBorderColor: hexColorAlphaObjToString(
      //             xmlData.getProperty("color"),
      //             parseFloat(xmlData.getProperty("alpha"))
      //         ),
      //         blink: 0,
      //     };

      break;
  }

  return {
    type: 0,
    url: ""
  };
}

function generateEmbedData(xmlData) {
  if (xmlData.hasProperty("embed_type") && xmlData.getProperty("embed_type") == "1" && xmlData.hasProperty("link") && xmlData.getProperty("link") != "") {
    if (xmlData.getProperty("link").toLowerCase().includes("http")) {
      return {
        code: 0,
        title: xmlData.hasProperty("text") ? xmlData.hasProperty("text") : "",
        linkUrl: decodeURIComponent(xmlData.getProperty("link")),
        openMethod: xmlData.hasProperty("blank") && xmlData.getProperty("blank") == '1' ? 1 : xmlData.getProperty("blank") == '0' ? 2 : 0,
        turnOffBgMusicWhenLayerOpen: xmlData.hasProperty("music_pause") ? xmlData.hasProperty("music_pause") : 0,
        turnOffBgVoiceWhenLayerOpen: xmlData.hasProperty("sound_pause") ? xmlData.hasProperty("sound_pause") : 0
      };
    } else {
      return {
        code: 1,
        title: xmlData.hasProperty("text") ? xmlData.hasProperty("text") : "",
        mobiles: [{
          name: xmlData.hasProperty("text") ? xmlData.hasProperty("text") : "",
          mobile: xmlData.hasProperty("link") ? xmlData.hasProperty("link") : "",
          avatarMediaId: 0
        }]
      };
    }
  } else {
    return {
      code: 10
    };
  }
}

var generateHotspot = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(hotspotData, zOrder, originData, hotspotEditData, uid, preview, testEnv, productType) {
    var hotspot;
    return _regeneratorRuntime.wrap(function _callee6$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = hotspotData.id;
            _context7.t1 = hotspotData.title;
            _context7.t2 = parseInt(hotspotData.showTitle);
            _context7.t3 = zOrder;
            _context7.t4 = generateIcon(hotspotData, hotspotEditData, productType);
            _context7.next = 7;
            return generateHotspotData(hotspotData, hotspotEditData, originData, uid, preview, testEnv);

          case 7:
            _context7.t5 = _context7.sent;
            _context7.t6 = parseInt(hotspotData.keepViewV2);
            _context7.t7 = {
              align: "center",
              edge: "top",
              ox: 0,
              oy: -55,
              font: {
                fontSize: parseInt(hotspotData.fontSize),
                fontColor: "255,255,255,1"
              },
              background: {
                bgColor: "0,0,0,0.5",
                bgRoundedge: 5,
                borderWidth: 0,
                borderColor: "0,0,0,1"
              }
            };
            hotspot = {
              id: _context7.t0,
              title: _context7.t1,
              showTitle: _context7.t2,
              zOrder: _context7.t3,
              icon: _context7.t4,
              data: _context7.t5,
              keepView: _context7.t6,
              titleSetting: _context7.t7
            };
            return _context7.abrupt("return", hotspot);

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee6);
  }));

  return function generateHotspot(_x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();

function generateHotspotData(_x22, _x23, _x24, _x25, _x26, _x27) {
  return _generateHotspotData.apply(this, arguments);
}

function _generateHotspotData() {
  _generateHotspotData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(hotspotData, hotspotEditData, originData, uid, preview, testEnv) {
    var sceneId, json, i, j, _i8, _j, imgs, target, id, path, _yield$createFrameMed, mediaId, frameId, articlesId, articleId;

    return _regeneratorRuntime.wrap(function _callee10$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.t0 = hotspotData.type;
            _context11.next = _context11.t0 === 0 ? 3 : _context11.t0 === 1 ? 6 : _context11.t0 === 2 ? 7 : _context11.t0 === 3 ? 9 : _context11.t0 === 4 ? 11 : _context11.t0 === 5 ? 12 : _context11.t0 === 6 ? 13 : _context11.t0 === 7 ? 14 : _context11.t0 === 9 ? 32 : 45;
            break;

          case 3:
            //全景切换
            sceneId = 0;

            if (hotspotData.data.sceneId == "") {
              json = originData.data;

              for (i = 0; i < json.product.config.category.length; i++) {
                for (j = 0; j < json.product.config.category[i].scenes.length; j++) {
                  if (parseInt(json.product.config.category[i].scenes[j].panoId) == parseInt(hotspotData.data.panoId)) {
                    sceneId = parseInt(json.product.config.category[i].scenes[j].id);
                  }
                }
              }

              for (_i8 = 0; _i8 < json.product.config.category.length; _i8++) {
                for (_j = 0; _j < json.product.config.category[_i8].scenes.length; _j++) {
                  if (parseInt(json.product.config.category[_i8].scenes[_j].materialId) == parseInt(hotspotData.data.materialId)) {
                    sceneId = parseInt(json.product.config.category[_i8].scenes[_j].id);
                  }
                }
              }
            } else {
              sceneId = parseInt(hotspotData.data.sceneId);
            }

            return _context11.abrupt("return", {
              code: 9,
              title: hotspotData.title,
              sceneId: sceneId,
              animation: parseInt(hotspotData.data.effect),
              exitTargetView: {
                type: 0
              },
              enterInitView: {
                type: hotspotData.data.panoId ? parseInt(hotspotData.keepViewV2) : 0
              },
              enterTargetView: {
                type: 0
              }
            });

          case 6:
            return _context11.abrupt("return", {
              code: 0,
              title: hotspotData.title,
              linkUrl: decodeURIComponent(hotspotData.url),
              openMethod: parseInt(hotspotData.blank) == 1 ? 1 : parseInt(hotspotData.blank) == 0 ? 2 : 0
            });

          case 7:
            //图片展示，
            imgs = hotspotData.data.map(function (item) {
              var media = hotspotEditData.target.filter(function (media) {
                return media.url === item;
              }).at(0);
              return media ? {
                mediaId: media.mediaId,
                mediaUrl: item,
                content: ""
              } : null;
            }).filter(function (item) {
              return item !== null;
            });
            return _context11.abrupt("return", {
              code: 3,
              title: hotspotData.title,
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: parseInt(hotspotData.blank) == 1 ? 1 : parseInt(hotspotData.blank) == 0 ? 2 : 0,
              layoutStyle: 2,
              imgs: hotspotData.data.map(function (item) {
                var media = hotspotEditData.target.filter(function (media) {
                  return media.url === item;
                }).at(0);
                return media ? {
                  mediaId: media.mediaId,
                  mediaUrl: item,
                  content: ""
                } : null;
              }).filter(function (item) {
                return item !== null;
              })
            });

          case 9:
            //视频热点
            target = hotspotData.target;
            return _context11.abrupt("return", {
              code: 7,
              title: hotspotData.title,
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: parseInt(hotspotData.blank) == 1 ? 1 : parseInt(hotspotData.blank) == 0 ? 2 : 0,
              iframeVideo: hotspotData.text == undefined ? hotspotData.data : hotspotData.text,
              videos: [{
                mediaId: hotspotEditData.target[0] ? hotspotEditData.target[0].videoMediaId : 0,
                mediaUrl: target ? hotspotData.target[0].videoMediaUrl : hotspotData.subData.videoUrl,
                mediaName: target ? hotspotData.target[0].videoName : hotspotData.subData.videoName,
                coverMediaUrl: target ? hotspotData.target[0].coverUrl : hotspotData.subData.coverUrl
              }]
            });

          case 11:
            return _context11.abrupt("return", {
              code: 4,
              title: hotspotData.title,
              content: hotspotData.data,
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: parseInt(hotspotData.blank) == 1 ? 1 : parseInt(hotspotData.blank) == 0 ? 2 : 0
            });

          case 12:
            return _context11.abrupt("return", {
              code: 6,
              title: hotspotData.title,
              type: 1,
              musicMediaId: hotspotEditData.target[0].mediaId,
              musicMediaUrl: hotspotData.data,
              musicMediaName: hotspotData.title,
              musicVolume: parseFloat(hotspotData.volume),
              musicLoop: parseInt(hotspotData.isLoop),
              turnOffBgMusicOnPlay: hotspotData.subData ? parseInt(hotspotData.subData.shutDownBgOnPlay) : 1,
              turnOffBgVoiceonPlay: hotspotData.subData ? parseInt(hotspotData.subData.shutDownVoiceOnPlay) : 1,
              turnOffRotateOnPlay: hotspotData.subData ? parseInt(hotspotData.subData.shutDownVoiceOnPlay) : 1
            });

          case 13:
            return _context11.abrupt("return", {
              code: 3,
              title: hotspotData.title,
              imgs: hotspotData.data.map(function (item) {
                return {
                  mediaId: hotspotEditData.target[hotspotData.data.indexOf(item)].mediaId,
                  mediaUrl: item.image,
                  content: item.text
                };
              }),
              type: 1,
              musicMediaId: hotspotEditData.subTarget ? hotspotEditData.subTarget.musicId : undefined,
              musicMediaUrl: hotspotData.subData ? hotspotData.subData.musicUrl : undefined,
              musicMediaName: hotspotData.subData ? hotspotData.subData.musicName : undefined,
              musicVolume: hotspotData.subData ? parseFloat(hotspotData.subData.volume) : undefined,
              musicLoop: hotspotData.subData ? parseFloat(hotspotData.subData.isLoop) : 0,
              turnOffBgMusicOnPlay: hotspotData.subData ? parseFloat(hotspotData.subData.shutDownBgOnPlay) : undefined,
              turnOffBgVoiceOnPlay: hotspotData.subData ? parseFloat(hotspotData.subData.shutDownVoiceOnPlay) : undefined,
              turnOffRotateOnPlay: hotspotData.subData ? parseFloat(hotspotData.subData.shutDownVoiceOnPlay) : undefined,
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: parseInt(hotspotData.blank) == 1 ? 1 : parseInt(hotspotData.blank) == 0 ? 2 : 0,
              layoutStyle: 2
            });

          case 14:
            if (!preview) {
              _context11.next = 16;
              break;
            }

            return _context11.abrupt("return", {
              code: 4,
              title: hotspotData.title,
              content: '预览暂不支持环物热点, 请转化后查看',
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: 0
            });

          case 16:
            id = '';
            path = '';
            _context11.prev = 18;
            _context11.next = 21;
            return createFrameMedia(hotspotData.title, hotspotData.data.images.map(function (item) {
              return "https://ssl-media.720static.com/@/" + item;
            }), uid, testEnv);

          case 21:
            _yield$createFrameMed = _context11.sent;
            mediaId = _yield$createFrameMed.mediaId;
            frameId = _yield$createFrameMed.frameId;
            id = mediaId;
            path = "/" + uid + "/4/seq_" + frameId;
            _context11.next = 30;
            break;

          case 28:
            _context11.prev = 28;
            _context11.t1 = _context11["catch"](18);

          case 30:
            return _context11.abrupt("return", {
              code: 8,
              title: hotspotData.title,
              imgs: {
                mediaId: id,
                mediaPath: path,
                mediaFrame: hotspotData.data.images.length,
                mediaSuffix: hotspotData.data.images[0].split('.').pop()
              },
              content: hotspotData.data.text,
              playMethod: hotspotData.subData ? hotspotData.subData.playType == undefined ? 2 : hotspotData.subData.playType : 2,
              playSpeed: hotspotData.subData ? hotspotData.subData.playSpeed == undefined ? 24 : hotspotData.subData.playSpeed : 24,
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: parseInt(hotspotData.blank) == 1 ? 1 : parseInt(hotspotData.blank) == 0 ? 2 : 0
            });

          case 32:
            if (!preview) {
              _context11.next = 34;
              break;
            }

            return _context11.abrupt("return", {
              code: 4,
              title: hotspotData.title,
              content: '预览暂不支持文章热点, 请转化后查看',
              linkTitle: hotspotData.linkTitle,
              linkUrl: hotspotData.url,
              openMethod: 0
            });

          case 34:
            articlesId = [];
            _context11.prev = 35;
            _context11.next = 38;
            return createAtricle(hotspotData.title, hotspotData.data, testEnv);

          case 38:
            articleId = _context11.sent;
            articlesId = [articleId];
            _context11.next = 44;
            break;

          case 42:
            _context11.prev = 42;
            _context11.t2 = _context11["catch"](35);

          case 44:
            return _context11.abrupt("return", {
              code: 5,
              title: hotspotData.title,
              articles: articlesId,
              turnOffBgMusicOnPlay: parseInt(hotspotData.subData != undefined ? hotspotData.subData.shutDownBgOnPlay : 1),
              turnOffBgVoiceOnPlay: parseInt(hotspotData.subData != undefined ? hotspotData.subData.shutDownVoiceOnPlay : 1),
              turnOffRotateOnPlay: parseInt(hotspotData.subData != undefined ? hotspotData.subData.shutDownVoiceOnPlay : 1)
            });

          case 45:
            return _context11.abrupt("return", {
              code: 10
            });

          case 46:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee10, null, [[18, 28], [35, 42]]);
  }));
  return _generateHotspotData.apply(this, arguments);
}

function generateIcon(hotspotData, hotspotEditData, productType) {
  var legacySystemIconUrls = {
    "/v2/hotspot/80/new_spotd1.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/new_spotd10.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/new_spotd10_gif.png": "/hotspots/system/wugongnen/dian.png",
    "/v2/hotspot/80/new_spotd11.png": "/hotspots/system/changjingqiehuan/zhishengji1.png",
    "/v2/hotspot/80/new_spotd11_gif.png": "/hotspots/system/changjingqiehuan/zhishengji.png",
    "/v2/hotspot/80/new_spotd12.png": "/hotspots/system/daohang/biaoji1.png",
    "/v2/hotspot/80/new_spotd12_gif.png": "/hotspots/system/daohang/biaoji2.png",
    "/v2/hotspot/80/new_spotd1_gif.png": "/hotspots/system/changjingqiehuan/qianjin2.png",
    "/v2/hotspot/80/new_spotd2.png": "/hotspots/system/changjingqiehuan/zuozhuan1.png",
    "/v2/hotspot/80/new_spotd2_gif.png": "/hotspots/system/changjingqiehuan/zuozhuan2.png",
    "/v2/hotspot/80/new_spotd3.png": "/hotspots/system/changjingqiehuan/youzhuan1.png",
    "/v2/hotspot/80/new_spotd3_gif.png": "/hotspots/system/changjingqiehuan/youzhuan2.png",
    "/v2/hotspot/80/new_spotd4.png": "/hotspots/system/changjingqiehuan/zuozhuan1.png",
    "/v2/hotspot/80/new_spotd4_gif.png": "/hotspots/system/changjingqiehuan/zuozhuan2.png",
    "/v2/hotspot/80/new_spotd5.png": "/hotspots/system/changjingqiehuan/youzhuan1.png",
    "/v2/hotspot/80/new_spotd5_gif.png": "/hotspots/system/changjingqiehuan/youzhuan2.png",
    "/v2/hotspot/80/new_spotd6.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/new_spotd6_gif.png": "/hotspots/system/wugongnen/dian.png",
    "/v2/hotspot/80/new_spotd7.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/new_spotd7_gif.png": "/hotspots/system/wugongnen/dian.png",
    "/v2/hotspot/80/new_spotd8.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/new_spotd8_gif.png": "/hotspots/system/wugongnen/dian.png",
    "/v2/hotspot/80/new_spotd9.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/new_spotd9_gif.png": "/hotspots/system/wugongnen/dian.png",
    "/v2/hotspot/80/spot1.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot10.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot11.png": "/hotspots/system/chaolianjie/lianjie.png",
    "/v2/hotspot/80/spot12.png": "/hotspots/system/daohang/biaoji1.png",
    "/v2/hotspot/80/spot13.png": "/hotspots/system/shijian/shijian.png",
    "/v2/hotspot/80/spot14.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spot15.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spot16.png": "/hotspots/system/changjingqiehuan/youzhuan1.png",
    "/v2/hotspot/80/spot17.png": "/hotspots/system/changjingqiehuan/zuozhuan1.png",
    "/v2/hotspot/80/spot18.png": "/hotspots/system/changjingqiehuan/zuozhuan1.png",
    "/v2/hotspot/80/spot19.png": "/hotspots/system/changjingqiehuan/youzhuan1.png",
    "/v2/hotspot/80/spot2.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot20.png": "/v2/hotspot/80/spot20.png",
    "/v2/hotspot/80/spot21.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spot3.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spot4.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot5.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spot6.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot7.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot8.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spot9.png": "/hotspots/system/shijian/shijian.png",
    "/v2/hotspot/80/spotd1.png": "/hotspots/system/changjingqiehuan/zhishengji1.png",
    "/v2/hotspot/80/spotd1_gif.png": "/hotspots/system/changjingqiehuan/zhishengji.png",
    "/v2/hotspot/80/spotd2.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spotd21.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spotd2_gif.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spotd3.png": "/hotspots/system/changjingqiehuan/qianjin1.png",
    "/v2/hotspot/80/spotd3_gif.png": "/hotspots/system/changjingqiehuan/qianjin2.png",
    "/v2/hotspot/80/spotd4.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spotd4_gif.png": "/hotspots/system/changjingqiehuan/yuandian.png",
    "/v2/hotspot/80/spotd5.png": "/hotspots/system/wugongnen/kongbai.png",
    "/v2/hotspot/80/spotd5_gif.png": "/hotspots/system/changjingqiehuan/3Dbiaoji.png",
    "/v2/hotspot/80/static_gallery.png": "/hotspots/system/tupian/tupian1.png",
    "/v2/hotspot/80/static_link.png": "/hotspots/system/chaolianjie/lianjie.png",
    "/v2/hotspot/80/static_music.png": "/hotspots/system/yinyue/yinping.png",
    "/v2/hotspot/80/static_txt.png": "/hotspots/system/wenzi/wenzi1.png",
    "/v2/hotspot/80/static_video.png": "/hotspots/system/shiping/shiping1.png"
  };
  var icon = {
    ath: parseFloat(hotspotData.ath == undefined ? 0 : hotspotData.ath),
    atv: parseFloat(hotspotData.atv == undefined ? 0 : hotspotData.atv) + 5,
    scaleX: 0.5 * (hotspotData.iconSize || 1),
    scaleY: 0.5 * (hotspotData.iconSize || 1),
    edge: "center"
  };

  switch (hotspotData.imageType || hotspotData.iconType) {
    case 0:
      //多边形
      icon.type = 5;
      icon.points = hotspotData.vectorIcon.vertexs;
      icon.fillColor = hexColorAlphaObjToString(hotspotData.vectorIcon.defaultState.fillColor, hotspotData.vectorIcon.defaultState.fillColorAlpha);
      icon.borderColor = hexColorAlphaObjToString(hotspotData.vectorIcon.defaultState.borderColor, hotspotData.vectorIcon.defaultState.borderColorAlpha);
      icon.borderWidth = hotspotData.vectorIcon.defaultState.borderWidth;
      icon.overFillColor = hexColorAlphaObjToString(hotspotData.vectorIcon.hoverState.fillColor, hotspotData.vectorIcon.hoverState.fillColorAlpha);
      icon.overBorderColor = hexColorAlphaObjToString(hotspotData.vectorIcon.hoverState.borderColor, hotspotData.vectorIcon.hoverState.borderColorAlpha);
      icon.overBorderWidth = hotspotData.vectorIcon.hoverState.borderWidth;
      icon.blink = 0;
      icon.ath = icon.points.filter(function (item) {
        return item.atv == Math.min.apply(Math, icon.points.map(function (item) {
          return item.atv;
        }));
      })[0].ath;
      icon.atv = Math.min.apply(Math, icon.points.map(function (item) {
        return item.atv;
      })) - (productType == 1 ? 2 : 0);
      break;

    case 1:
      //系统
      icon.type = 0;
      icon.url = hotspotData.iconUrl || hotspotData.imageUrl;
      icon.frame = (hotspotData.iconUrl || hotspotData.imageUrl).includes("_gif") ? 25 : 1;
      break;

    case 2:
      //媒体库
      icon.type = hotspotData.isFrame == 0 ? 2 : 3;
      icon.positionType = 0;
      icon.stick = 0;
      icon.scaleX = 0.75 * hotspotData.iconSize;
      icon.scaleY = 0.75 * hotspotData.iconSize;
      icon.scaleLock = true;
      icon.media = hotspotData.isFrame == 0 ? [{
        id: hotspotEditData.styleId,
        url: hotspotData.iconUrl || hotspotData.imageUrl
      }] : [{
        id: hotspotEditData.styleId,
        url: hotspotData.iconUrl || hotspotData.imageUrl,
        width: hotspotData.frameWidth,
        height: hotspotData.frameHeight,
        frame: hotspotData.frameNumber,
        duration: hotspotData.frameSpeed
      }];
      break;
  }

  return icon;
}

function generateModel(_x28, _x29, _x30, _x31, _x32) {
  return _generateModel.apply(this, arguments);
}

function _generateModel() {
  _generateModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(linkData, editLinkData, testEnv, uid, preview) {
    var loc, items, linkDatas, articlesId, articleId, id, path, _yield$createFrameMed2, mediaId, frameId;

    return _regeneratorRuntime.wrap(function _callee12$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (preview === void 0) {
              preview = true;
            }

            _context13.t0 = linkData.action;
            _context13.next = _context13.t0 === 1 ? 4 : _context13.t0 === 2 ? 10 : _context13.t0 === 3 ? 13 : _context13.t0 === 4 ? 16 : _context13.t0 === 6 ? 21 : _context13.t0 === 7 ? 35 : _context13.t0 === 8 ? 37 : 55;
            break;

          case 4:
            if (!linkData.link.toLowerCase().includes("http")) {
              _context13.next = 8;
              break;
            }

            return _context13.abrupt("return", {
              code: 0,
              title: linkData.title,
              linkUrl: decodeURIComponent(linkData.link),
              openMethod: linkData.blank == 1 ? 1 : linkData.blank == 0 ? 2 : 0,
              turnOffBgMusicOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownBgOnPlay),
              // 播放时关闭背景音乐, 0:不关闭 1:关闭 默认1
              turnOffBgVoiceOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay),
              // 播放时关闭背景讲解, 0:不关闭 1:关闭 默认1
              turnOffRotateOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay)
            });

          case 8:
            return _context13.abrupt("return", {
              code: 1,
              title: linkData.title,
              mobiles: [{
                name: linkData.title,
                mobile: decodeURIComponent(linkData.link).replace('tel://', ''),
                avatarMediaId: 0
              }]
            });

          case 9:
            return _context13.abrupt("break", 56);

          case 10:
            //导航
            loc = JSON.parse(linkData.link);
            return _context13.abrupt("return", {
              code: 2,
              title: linkData.title,
              location: {
                zoom: loc.zoom,
                lat: loc.lat,
                lng: loc.lng
              }
            });

          case 13:
            //图文混排
            items = editLinkData.data ? editLinkData.data : [];
            return _context13.abrupt("return", {
              code: 3,
              title: linkData.title,
              imgs: items.map(function (item) {
                return {
                  mediaId: item.mediaId,
                  mediaUrl: item.mediaUrl,
                  content: item.text // 文本内容

                };
              }),
              type: 1,
              // 音乐类型 0:系统音乐 1:自定义音乐
              musicMediaId: editLinkData.subData ? editLinkData.subData.mediaId : undefined,
              musicMediaUrl: linkData.subData == undefined ? "" : linkData.subData.musicUrl,
              musicMediaName: linkData.subData == undefined ? "" : linkData.subData.musicName,
              musicVolume: linkData.subData == undefined ? 1 : linkData.subData.volume,
              musicLoop: linkData.subData == undefined ? 0 : parseInt(linkData.subData.isLoop),
              // 循环播放, 0:不循环 1:循环 默认1
              turnOffBgMusicOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownBgOnPlay),
              // 播放时关闭背景音乐, 0:不关闭 1:关闭 默认1
              turnOffBgVoiceOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay),
              // 播放时关闭背景讲解, 0:不关闭 1:关闭 默认1
              turnOffRotateOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay),
              linkTitle: linkData.linkTitle,
              // 更多内容标题
              linkUrl: linkData.link,
              openMethod: linkData.blank == 1 ? 1 : linkData.blank == 0 ? 2 : 0,
              // 打开链接方式, 0:弹窗 1:新窗口 2:本窗口 默认1
              layoutStyle: 2 // 布局方式, 0:左右切换 1:瀑布流 默认0

            });

          case 16:
            //分组
            linkDatas = linkData.data;
            _context13.next = 19;
            return Promise.all(linkDatas.flatMap( /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(newLinkData) {
                return _regeneratorRuntime.wrap(function _callee11$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return generateModel(newLinkData, editLinkData.data[linkDatas.indexOf(newLinkData)], testEnv, uid, preview);

                      case 2:
                        return _context12.abrupt("return", _context12.sent);

                      case 3:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee11);
              }));

              return function (_x41) {
                return _ref12.apply(this, arguments);
              };
            }()));

          case 19:
            return _context13.abrupt("return", _context13.sent);

          case 21:
            if (!preview) {
              _context13.next = 23;
              break;
            }

            return _context13.abrupt("return", {
              code: 4,
              title: linkData.title && linkData.title != '' ? linkData.title : '查看文章',
              content: '预览暂不支持文章, 请转化后查看',
              linkTitle: linkData.linkTitle,
              linkUrl: linkData.url,
              openMethod: 0
            });

          case 23:
            articlesId = [];
            _context13.prev = 24;
            _context13.next = 27;
            return createAtricle(linkData.title ? linkData.title : '查看文章', linkData.data, testEnv);

          case 27:
            articleId = _context13.sent;
            articlesId = [articleId];
            _context13.next = 33;
            break;

          case 31:
            _context13.prev = 31;
            _context13.t1 = _context13["catch"](24);

          case 33:
            return _context13.abrupt("return", {
              code: 5,
              // 文章
              title: linkData.title,
              // 按钮标题
              articles: articlesId,
              // 文章素材ID TODO
              turnOffBgMusicOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownBgOnPlay),
              // 播放时关闭背景音乐, 0:不关闭 1:关闭 默认1
              turnOffBgVoiceOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay),
              // 播放时关闭背景讲解, 0:不关闭 1:关闭 默认1
              turnOffRotateOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay)
            });

          case 35:
            return _context13.abrupt("return", {
              code: 7,
              // 视频
              title: linkData.title,
              // 按钮标题
              videos: [{
                mediaId: editLinkData.subData ? editLinkData.subData.videoMediaId : undefined,
                mediaUrl: linkData.subData == undefined ? "" : linkData.subData.videoUrl,
                mediaName: linkData.subData == undefined ? "" : linkData.subData.videoName,
                coverMediaUrl: linkData.subData == undefined ? "" : linkData.subData.coverUrl // 视频封面地址

              }],
              // 素材库视频
              iframeVideo: linkData.data,
              // 第三方嵌入视频
              turnOffBgMusicOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownBgOnPlay),
              // 播放时关闭背景音乐, 0:不关闭 1:关闭 默认1
              turnOffBgVoiceOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay),
              // 播放时关闭背景讲解, 0:不关闭 1:关闭 默认1
              turnOffRotateOnPlay: parseInt(linkData.subData == undefined ? 1 : linkData.subData.shutDownVoiceOnPlay),
              linkTitle: linkData.linkTitle,
              // 更多内容标题
              linkUrl: linkData.detail,
              // 更多内容地址
              openMethod: linkData.blank == 1 ? 1 : linkData.blank == 0 ? 2 : 0,
              // 打开链接方式, 0:弹窗 1:新窗口 2:本窗口 默认1
              layoutStyle: 2
            });

          case 37:
            if (!preview) {
              _context13.next = 39;
              break;
            }

            return _context13.abrupt("return", {
              code: 4,
              title: linkData.title && linkData.title != '' ? linkData.title : '查看环物',
              content: '预览暂不支持环物功能, 请转化后查看',
              linkTitle: linkData.linkTitle,
              linkUrl: linkData.url,
              openMethod: 0
            });

          case 39:
            id = '';
            path = '';
            _context13.prev = 41;
            _context13.next = 44;
            return createFrameMedia(linkData.title ? linkData.title : '', linkData.data.images.map(function (item) {
              return "https://ssl-media.720static.com/@/" + item;
            }), uid, testEnv);

          case 44:
            _yield$createFrameMed2 = _context13.sent;
            mediaId = _yield$createFrameMed2.mediaId;
            frameId = _yield$createFrameMed2.frameId;
            id = mediaId;
            path = "/" + uid + "/4/seq_" + frameId;
            _context13.next = 53;
            break;

          case 51:
            _context13.prev = 51;
            _context13.t2 = _context13["catch"](41);

          case 53:
            return _context13.abrupt("return", {
              code: 8,
              title: linkData.title,
              imgs: {
                mediaId: id,
                mediaPath: path,
                mediaFrame: linkData.data.images.length,
                mediaSuffix: linkData.data.images[0].split('.').pop()
              },
              content: linkData.data.text,
              playMethod: linkData.subData == undefined ? 2 : linkData.subData.playType,
              // 播放设置, 0:不自动播放 1:自动播放(只播放一次) 2:自动播放(循环) 默认2
              playSpeed: linkData.subData == undefined ? 24 : linkData.subData.playSpeed,
              // 每秒多少帧 默认24
              linkTitle: linkData.linkTitle,
              // 更多内容标题
              linkUrl: linkData.detail,
              // 更多内容地址
              openMethod: parseInt(linkData.blank) == 1 ? 1 : parseInt(linkData.blank) == 0 ? 2 : 0 // 打开链接方式, 0:弹窗 1:新窗口 2:本窗口 默认1

            });

          case 55:
            return _context13.abrupt("return", []);

          case 56:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee12, null, [[24, 31], [41, 51]]);
  }));
  return _generateModel.apply(this, arguments);
}

function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

function hexColorAlphaObjToString(hex, alpha) {
  var rgb = hexToRgb(hex);
  return colorAlphaObjToString(rgb || {
    r: 0,
    g: 0,
    b: 0
  }, alpha || (alpha == 0 ? 0 : 1));
}

function colorAlphaObjToString(color, alpha) {
  var r = color.r,
      g = color.g,
      b = color.b;
  return r + "," + g + "," + b + "," + alpha;
}

function isEmpty(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

var docCookies = {
  getItem: function getItem(sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }

    var sExpires = "";

    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;

        case String:
          sExpires = "; expires=" + vEnd;
          break;

        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }

    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) {
      return false;
    }

    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function hasItem(sKey) {
    return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
  },
  keys:
  /* optional method: you can safely remove it! */
  function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);

    for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }

    return aKeys;
  }
};

var createAtricle = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(title, text, testEnv) {
    var url, formData, id;
    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = "https://" + (testEnv ? 'api-test' : 'apiv4') + ".720yun.com/member/my/media/article";
            formData = new FormData();
            formData.append('title', title);
            formData.append('text', text);
            formData.append('thumb', '');
            _context8.next = 7;
            return fetch(url, {
              method: 'POST',
              headers: {
                'App-Authorization': docCookies.getItem('720yun_v8_token'),
                'App-Key': 'eByjUyLDG2KtkdhuTsw2pY46Q3ceBPdT'
              },
              body: formData
            }).then(function (response) {
              return response.json();
            }).then(function (result) {
              if (result.success == '1') {
                return result.data.id;
              }

              throw new Error('error');
            });

          case 7:
            id = _context8.sent;
            return _context8.abrupt("return", id);

          case 9:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7);
  }));

  return function createAtricle(_x33, _x34, _x35) {
    return _ref9.apply(this, arguments);
  };
}();

var createFrameMedia = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(title, images, uid, testEnv) {
    var frameId, fileExtension, sizeCount, uptokenUrl, uptoken, imagesData, url, formData, mediaId;
    return _regeneratorRuntime.wrap(function _callee9$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            frameId = makeid(20);
            fileExtension = images[0].split('.').pop();
            sizeCount = 0;
            uptokenUrl = "https://api-qiniu" + (testEnv ? '-test' : 'v2') + ".720yun.com/uptoken/media";
            _context10.next = 6;
            return fetch(uptokenUrl, {
              method: 'GET',
              headers: {
                'App-Authorization': docCookies.getItem('720yun_v8_token'),
                'App-Key': 'eByjUyLDG2KtkdhuTsw2pY46Q3ceBPdT'
              }
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              return data.data.token;
            });

          case 6:
            uptoken = _context10.sent;
            _context10.next = 9;
            return Promise.all(images.map( /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(image) {
                var data, formData, res;
                return _regeneratorRuntime.wrap(function _callee8$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return fetch(image).then(function (res) {
                          return res.blob();
                        });

                      case 2:
                        data = _context9.sent;
                        sizeCount += data.length;
                        formData = new FormData();
                        formData.append('file', data);
                        formData.append('key', "/" + uid + "/4/seq_" + frameId + "/" + (images.indexOf(image) + 1) + "." + fileExtension);
                        formData.append('token', uptoken);
                        _context9.next = 10;
                        return fetch('https://upload.qiniup.com/', {
                          method: "POST",
                          body: formData
                        });

                      case 10:
                        res = _context9.sent;
                        return _context9.abrupt("return", res);

                      case 12:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x40) {
                return _ref11.apply(this, arguments);
              };
            }()));

          case 9:
            imagesData = _context10.sent;
            url = "https://" + (testEnv ? 'api-test' : 'apiv4') + ".720yun.com/member/my/media";
            formData = new FormData();
            formData.append('url', "/" + uid + "/4/seq_" + frameId);
            formData.append('type', 4);
            formData.append('frame', images.length);
            formData.append('suffix', fileExtension);
            formData.append('size', images.length);
            formData.append('name', title);
            formData.append('albumId', 0);
            _context10.next = 21;
            return fetch(url, {
              method: 'POST',
              headers: {
                'App-Authorization': docCookies.getItem('720yun_v8_token'),
                'App-Key': 'eByjUyLDG2KtkdhuTsw2pY46Q3ceBPdT'
              },
              body: formData
            }).then(function (response) {
              return response.json();
            }).then(function (result) {
              if (result.success == '1') {
                return result.data.mediaId;
              }

              throw new Error('error');
            });

          case 21:
            mediaId = _context10.sent;
            return _context10.abrupt("return", {
              frameId: frameId,
              mediaId: mediaId
            });

          case 23:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee9);
  }));

  return function createFrameMedia(_x36, _x37, _x38, _x39) {
    return _ref10.apply(this, arguments);
  };
}();

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;

  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

var toNewVersionVideo = function toNewVersionVideo(originData, editData, testEnv, preview) {
  var str = originData.xml;
  var xml = new XML(str);
  var json = originData.data;
  var flag = {
    showAuthorName: editData.flag.show_author,
    showTourPV: editData.flag.enable_pv,
    showTourRemark: 1,
    showFullscreenBtn: 1,
    showVRBtn: editData.flag.enable_vr,
    showViewSwitchBtn: editData.flag.enable_viewchange,
    showGyroBtn: editData.flag.show_gyro,
    defaultEnabledGyro: editData.flag.gyroscope,
    showShareBtn: 1,
    showLikeBtn: 1,
    showCommentBtn: preview ? 0 : json.product.config["switch"].enableComment != undefined ? json.product.config["switch"].enableComment : 1,
    showComment: preview ? 0 : json.product.config["switch"].showComment != undefined ? json.product.config["switch"].showComment : 1,
    showSceneName: 1,
    showRemarkBtn: 1,
    dragMode: 1,
    showAutoRotateBtn: 1,
    enableBouncing: 1,
    checkCommentByAuthor: 0,
    showCommentBtnV2: preview ? 0 : json.product.config["switch"].enableComment != undefined ? json.product.config["switch"].enableComment : 1
  };
  var panoData = {
    flag: JSON.stringify(flag),
    // memberId: 1208088,
    // expireDate: null,
    // createDate: 1661142166,
    version: 2,
    // expired: 1,
    shareConfig: "{}",
    privilege: json.product.config["switch"].enablePassword == 1 && !preview && json.author.expired == 0 ? 2 : 1,
    // tid: "f3am07ctusr",
    remark: editData.remark.length <= 1999 ? editData.remark : editData.remark.slice(0, 1999),
    keywords: editData.keywords,
    status: 0,
    // memberUid: "5a1jO5twsw8",
    channel: {},
    // pvCount: 4,
    // id: 3404,
    name: editData.name,
    sceneType: "0",
    likeCount: 0,
    // subChannel: null,
    selected: 0,
    sceneCount: 1,
    thumbUrl: editData.thumbUrl,
    templateId: 1,
    publishPlatform: 0,
    // updateDate: 1661142183,
    // json: "json/ad53f837s2y/5a1jO5twsw8/f3am07ctusr/2.json",
    author: json.author
  };
  var logo = isEmpty(json.product.config.logo) ? {} : {
    type: json.product.config.logo.enabled == 0 ? 0 : json.product.config.logo.url != "" ? 2 : 1,
    iconMediaId: editData.logo.media_id,
    iconMediaUrl: json.product.config.logo.url,
    scale: 1,
    action: json.product.config.logo.link && json.product.config.logo.link.length > 0 ? 1 : 0,
    linkUrl: json.product.config.logo.link,
    openMethod: 1,
    turnOffBgMusicWhenLayerOpen: 1,
    turnOffBgVoiceWhenLayerOpen: 1
  };
  var jsonData = {
    id: 0,
    tid: "",
    name: editData.name,
    remark: editData.remark.length <= 1999 ? editData.remark : editData.remark.slice(0, 1999),
    keywords: editData.keywords,
    thumbUrl: editData.thumbUrl,
    createDate: 0,
    updateDate: 0,
    templateId: 1,
    expired: json.author.expired,
    expireDate: "",
    privilege: json.product.config["switch"].enablePassword == 1 && !preview && json.author.expired == 0 ? 2 : 1,
    category: [{
      id: 1,
      name: "默认分组"
    }],
    categoryConfig: {
      enabledButton: 1,
      buttonMediaId: 0,
      buttonMediaUrl: "",
      buttonTitle: "",
      enabledColumn: 1,
      columnStyle: 0,
      categoryAutoSwitch: 0,
      switchCategoryShowFirstScene: 0,
      isDefaultShowColumn: 1,
      initScene: 0,
      effect: 0
    },
    logo: logo,
    flag: flag,
    enterCover: {},
    startAnime: {
      pano: 1,
      video: 1,
      matrix: 1
    },
    autoRotate: {
      enabled: 0,
      duration: 180,
      autoEnterNext: 1,
      hiddenThumbSceneNoEnter: 1
    },
    tourTip: {},
    config: {
      loading: json.product.config.loading
    },
    customButton: [],
    version: 2,
    scenes: editData.scenes.map(function (scene) {
      return {
        id: scene.id,
        tourId: scene.id,
        type: 0,
        materialId: scene.materialId,
        name: scene.name,
        thumbUrl: scene.thumbUrl,
        categoryId: 1,
        createDate: 0,
        updateDate: 0,
        showThumb: 1,
        multires: {},
        matrixFov: {},
        transcodeTrack: scene.transcodeTrack,
        cdnDomain: scene.cdnDomain,
        path: "",
        view: {
          fovMax: scene.view.fovmax != undefined ? scene.view.fovmax : 120,
          fovMin: scene.view.fovmin != undefined ? scene.view.fovmin : 70,
          fov: scene.view.fov != undefined ? scene.view.fov : 95,
          fovType: "MFOV",
          loadSceneKeepView: 0,
          autoRotateKeepView: 0,
          vLookAt: scene.view.vlookat != undefined ? scene.view.vlookat : 0,
          vLookAtMax: scene.view.vlookatmax != undefined ? scene.view.vlookatmax : 90,
          vLookAtMin: scene.view.vlookatmin != undefined ? scene.view.vlookatmin : -90,
          hLookAt: scene.view.hlookat != undefined ? scene.view.hlookat : 0,
          hLookAtMax: scene.view.hlookatmax != undefined ? scene.view.hlookatmax : 180,
          hLookAtMin: scene.view.hlookatmin != undefined ? scene.view.hlookatmin : -180,
          flatFovType: 0,
          maxPixelZoom: 2
        },
        tid: "",
        mask: {},
        sort: 1,
        hotspot: [],
        groups: {},
        sound: {},
        voice: {},
        north: 0,
        sandBox: {},
        effect: [],
        config: {},
        video: [],
        subtitle: [],
        keypoint: [],
        tagLine: []
      };
    }),
    sandBox: [],
    shareConfig: JSON.stringify(editData.config.qrLogo && !isEmpty(editData.config.qrLogo) ? {
      qrMediaId: editData.config.qrLogo.mediaId,
      qrMediaUrl: editData.config.qrLogo.url
    } : {})
  };
  return {
    panoData: panoData,
    jsonData: jsonData
  };
};